module.exports = __webpack_public_path__ + "static/img/longjiaosan.1feed0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/longjiaosan.jpg
// module id = JtFj
// module chunks = 0